// Popup.tsx
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import deletemodelpopup from "../../assets/popup/deletemodelpopup.svg";

interface PopupForMessageProps {
  viewMembersOnly?: boolean;
  isOpen: boolean;
  onClose: () => void;
  showMessage?: any
  removeExtraCSS?: boolean
  msgHeading?: string
}
const PopupForMessage: React.FC<PopupForMessageProps> = ({ viewMembersOnly, isOpen, onClose, showMessage, removeExtraCSS, msgHeading }) => {
  useEffect(() => {
    document.body.classList.add("coverflow_hidden_scoll_bdy");

    return () => {
      document.body.classList.remove("coverflow_hidden_scoll_bdy");
    };
  }, []);

  if (!isOpen) return null;

  return (
    <section id="model-main-blg">
      <div id="inner_loader_dv">
        <div className={`w-[622px] flex flex-row items-start justify-start max-w-[622px] z-[1] mq825:max-w-full m-4 schedularaddmeeting_main ${viewMembersOnly ? "view_project_members" : ""}`}>
          <form
            className="responsive-model-popup-dv m-0 flex-1 rounded-radius-radius-lg bg-white border-[1px] border-solid border-surface-border flex flex-col items-center justify-start p-8 mq575:p-3 box-border gap-[23.8px] max-w-full mq825:pt-[21px] mq825:pb-[21px] mq825:box-border"
          >
            <div className="pt-0 p-8 pb-0 mq575:p-0 min-w-full relative">
              <div className='flex justify-between'>
                <b className="responsive-headeing-dv dark:text-white">{msgHeading}</b>
                {viewMembersOnly && (
                  <h3 className="m-0 h-[27px] flex-1 relative text-inherit font-bold font-inherit inline-block min-w-[82px] max-w-full mq450:text-base mb-3">View Members</h3>
                )}
                <img
                  src={deletemodelpopup}
                  alt=""
                  className="cursor-pointer absolute closeicon-model  dark-white-img  right-[20px]"
                  style={{ width: "20px", height: "20px" }}
                  onClick={onClose}
                />
              </div>
              <div className="model_content-cts-h">
                <div className="flex items-center gap-[16px] inner_model_content-blg">
                  <span className={`text-xl font-bold  text-black dark:text-white ${removeExtraCSS === true ? "min-w-full" : ""} `}>
                    {showMessage}
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default PopupForMessage;
